var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 11,
    height: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.9999C8.68642 20.0012 7.38546 19.7435 6.17162 19.2414C4.95777 18.7393 3.85485 18.0028 2.926 17.0739C1.99716 16.1451 1.26061 15.0421 0.75853 13.8283C0.256449 12.6144 -0.00131055 11.3135 5.01048e-06 9.9999V9.7999C0.0400133 7.83932 0.655299 5.93371 1.76939 4.31993C2.88348 2.70614 4.44726 1.45534 6.26636 0.722964C8.08547 -0.00940794 10.0797 -0.191052 12.0012 0.200608C13.9227 0.592268 15.6867 1.53996 17.074 2.9259C18.4737 4.32445 19.4271 6.10681 19.8134 8.04739C20.1997 9.98797 20.0017 11.9995 19.2443 13.8275C18.487 15.6555 17.2043 17.2177 15.5588 18.3165C13.9132 19.4152 11.9787 20.0011 10 19.9999ZM10 11.4099L12.59 13.9999L14 12.5899L11.41 9.9999L14 7.4099L12.59 5.9999L10 8.5899L7.41001 5.9999L6.00001 7.4099L8.59 9.9999L6.00001 12.5899L7.41001 13.9999L10 11.4109V11.4099Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.6b4a94b21c7fbc3d4580155fba7804d8.svg";
export { ForwardRef as ReactComponent };